<script lang="ts">
  import { XSSDeviationCategory } from "../Util/utils";

  export let category: XSSDeviationCategory;
</script>

{#if category == XSSDeviationCategory.Good}
  <i class="fa-solid fa-circle-check text-[var(--color-xss-deviation-good)]" />
{:else if category == XSSDeviationCategory.Warn}
  <i class="fa-solid fa-circle-exclamation text-[var(--color-xss-deviation-warn)]" />
{:else}
  <i class="fa-solid fa-circle-xmark text-[var(--color-xss-deviation-alert)]" />
{/if}
